/**
 * 巡更点
 */
import { Button, Form, Input, Modal, Select, message } from "antd";
import "./index.less";
import { DefaultStoreyUuid, GroupType } from "tnbimbase";
import { useContext, useEffect, useRef, useState } from "react";
import { graphicStore } from "@/commons/store/graphic-store";

import { ReactComponent as EditSvg } from './icons/edit.svg'
import { useParams } from "react-router-dom";
import SideBarTool from "@/commons/components/side-bar-tool";
import { StoreyStatus } from "@/commons/context/storey-store";
import { StoreyContext } from "@/App";
import { getStoreys, updateStorey } from "@/api/building/storey";
import { Storey } from "@/commons/interface/building/storey";
import classNames from "classnames";
import { BlockT, ModelBase, ViewEditor } from "pytha";
import { OrthographicCamera, Vector3 } from "three";
import { createPrimitiveMulti } from "@/api/geometry/primitive";

import { LoadingOutlined } from '@ant-design/icons';
import TnModal from "@/commons/widget/base-modal";
import ConfirmModal from "@/commons/widget/monix-modal";

import { ReactComponent as LinkSvg } from '@/commons/icons/panel-icon/link.svg';
import { ReactComponent as BindSvg } from '@/commons/icons/panel-icon/bind.svg';
import { ObjFile } from "@/commons/interface/geometry/obj-file";
import { bindObjFile, getObjFiles, updateObjFile } from "@/api/project/file";

interface IProps {
    width: number
}

export function StoreyPanel(props: IProps) {

    const { projectUuid, modelUuid } = useParams();
    const storeyContext = useContext<StoreyStatus>(StoreyContext);
    const [storeyList, setStoreyList] = useState<Storey[]>([]);
    const [editing, setEditing] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    const [selectedSet, setSelectedSet] = useState<Set<string>>(new Set());

    const [selectedUuid, setSelectedUuid] = useState('');

    const [editStoreyNumberModalOpen, setEditStoreyNumberModalOpen] = useState<boolean>(false); //是否激活绑定楼层弹窗
    const [form] = Form.useForm();

    const [showBindModel, setShowBindModel] = useState(false); // 是否显示绑定模型弹窗
    const [bindModelForm] = Form.useForm();
    const btnRef = useRef(null);
    const [bindLoading, setBindLoading] = useState<boolean>(false);
    const [objList, setObjList] = useState<ObjFile[]>([]); // obj文件列表

    const onClickBind = () => {
        if (bindLoading) return;
        if (btnRef.current) {
            btnRef.current.click();
        }
    }

    const onClickShowBindModel = (storey) => {
        bindModelForm.resetFields();
        bindModelForm.setFieldValue('storeyUuid', storey.uuid);
        setShowBindModel(true);
        setBindLoading(true);
        getObjFiles(projectUuid).then(res => {
            let list = res.data || [];
            list = list.filter(item => item.storeyUuid == null || item.storeyUuid == "" || item.storeyUuid == storey.uuid)
            setObjList(list);

            const obj = list.find(item => item.storeyUuid == storey.uuid);
            bindModelForm.setFieldValue('objUuid', obj?.id || '');
        }).finally(() => {
            setBindLoading(false);
        })
    }

    // 绑定模型
    const onBindModel = async () => {
        if (bindLoading) return;
        setBindLoading(true);
        const values = await bindModelForm.validateFields();
        let newObjUuid = values.objUuid;
        if (newObjUuid == null || newObjUuid == "") {
            newObjUuid = "-1";
        }
        bindObjFile(values.storeyUuid, newObjUuid).then(res => {
            message.success("修改成功");
            setShowBindModel(false);
        }).finally(() => {
            setBindLoading(false);
        })
    }

    const generateData = () => {
        if (!projectUuid || !modelUuid) {
            storeyContext.setStoreys([]);
            return;
        }
        getStoreys(projectUuid, modelUuid).then(res => {
            //为保持全局一致性，不直接从storeyContext中拿，每次都查询后更新
            if (res.status === 200) {
                let data: Storey[] = res.data || [];

                storeyContext.setStoreys(data);
                //按照楼层标高从高到低排序
                data.sort((a, b) => {
                    return - a.bottomElevation + b.bottomElevation;
                });
                setStoreyList(data);
            }
        }).catch(err => {
            console.log('err', err)
        })
    }

    useEffect(() => {
        generateData();
    }, [projectUuid, modelUuid])


    /**
     * 选中某个图元
     * @param editor 
     * @param selectedEntities 
     * @param entity 
     */
    const _selectEntity = (editor: ViewEditor, selectedEntities: ModelBase[], entity) => {
        selectedEntities.push(entity);
        editor.entityDict[entity.uuid].isSelected = true;
        editor.selectControl.addEntityToSelectedEntities(entity);
    }


    /**
     * 显示所有图元
     * @param model 
     * @returns 
     */
    const showEntity = (models: ModelBase[]) => {
        if (!models || models.length == 0) {
            return;
        }

        let x1 = +Infinity
        let y1 = +Infinity
        let x2 = -Infinity
        let y2 = -Infinity

        models.forEach(model => {
            let box = model.getBoundingBox();
            box.min.project(graphicStore.extraContext.getCurrentViewEditor().camera);
            box.max.project(graphicStore.extraContext.getCurrentViewEditor().camera);
            x1 = Math.min(box.min.x, x1);
            y1 = Math.min(box.min.y, y1);
            x2 = Math.max(box.max.x, x2);
            y2 = Math.max(box.max.y, y2);
        })

        if (x1 == null || y1 == null || x2 == null || y2 == null) {
            return
        }

        let scale1 = Math.abs(y1 - y2) / 2;

        let scale2 = Math.abs(x1 - x2) / 2;
        // max
        let scale = Math.max(scale1, scale2) * 1.3;
        let x = (x1 + x2) / 2;
        let y = (y1 + y2) / 2;
        let camera = graphicStore.extraContext.getCurrentViewEditor().camera;
        let target = graphicStore.context.ucsContext.unprojectCursorPoint(x, y, camera);

        let lastTarget = graphicStore.extraContext.getCurrentViewEditor().viewControl.target.clone();
        let offset = camera.position.clone().sub(lastTarget);
        const position = camera.position;
        graphicStore.extraContext.getCurrentViewEditor().viewControl.target.copy(target);
        position.copy(target).add(offset);
        graphicStore.extraContext.getCurrentViewEditor().camera.lookAt(target);
        // scale 框和当前边界的比例
        graphicStore.context.renderContext.cameraEdge *= scale;
        if (camera.type === "OrthographicCamera") {
            let orthoCamera = camera as OrthographicCamera;
            orthoCamera.left = orthoCamera.left * scale;
            orthoCamera.right = orthoCamera.right * scale;
            orthoCamera.top = orthoCamera.top * scale;
            orthoCamera.bottom = orthoCamera.bottom * scale;
            orthoCamera.updateProjectionMatrix();
        }


        graphicStore.extraContext.listeners.signals.onZoomChanged.dispatch(1 / scale);
    }



    const onEditiingClick = (storeyUuid: string, index: number) => {
        setLoading(true);
        message.info("选中或取消选中以更新楼层编组");
        setSelectedUuid(storeyUuid);
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) {
            message.error("图形编辑器未激活");
            setLoading(false);
            return;
        }
        //清空选择集
        editor.listeners.signals.emptySelectedEntities.dispatch();
        let entitiesInCurrentStorey: ModelBase[] = [];
        Object.keys(editor.entityDict).forEach(uuid => {
            let entity = editor.entityDict[uuid];
            if (!entity) return;
            //如果该图有编组属性，并且楼层编组属性存在，并且楼层编组数组的长度大于0
            if (entity.group && entity.group[GroupType.STOREY] && entity.group[GroupType.STOREY].length > 0) {
                //如果图元的楼层编组uuid为当前uuid，则加入到数组中
                if (entity.group[GroupType.STOREY][0] === storeyUuid) {
                    _selectEntity(editor, entitiesInCurrentStorey, entity);
                    //如果图元的楼层编组为动态指定，则计算其层高，将层高符合条件的图元全部加入
                } else if (entity.group[GroupType.STOREY][0] === DefaultStoreyUuid.DYNAMIC) {
                    //如果图元为块，直接用position判断高度，减少对于中心点的计算
                    if (entity instanceof BlockT) {
                        let block = entity as BlockT;
                        const z = block.position.z / 1000; //毫米与米换算
                        if (index === 0) {
                            if (z >= storeyList[index].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        } else if (index === storeyList.length - 1) {
                            if (z < storeyList[index - 1].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        } else {
                            if (z < storeyList[index - 1].bottomElevation && z >= storeyList[index].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        }
                    } else {
                        let vec = new Vector3();
                        entity.getCenter(vec)
                        const z = vec.z / 1000; //毫米与米换算
                        if (index === 0) {
                            if (z >= storeyList[index].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        } else if (index === storeyList.length - 1) {
                            if (z < storeyList[index - 1].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        } else {
                            if (z < storeyList[index - 1].bottomElevation && z >= storeyList[index].bottomElevation) {
                                _selectEntity(editor, entitiesInCurrentStorey, entity);
                            }
                        }
                    }
                }
            }
        });
        showEntity(entitiesInCurrentStorey);
        let uuids = entitiesInCurrentStorey.map(entity => entity.uuid);
        setSelectedSet(new Set(uuids));
        setEditing(true);
        editor.listeners.signals.needRender.dispatch("redraw");
        setLoading(false);
    }

    const onSave = () => {
        setLoading(true);
        if (!editing) {
            message.error("当前未处于编辑状态");
            setLoading(false);
            return;
        }
        if (!selectedUuid || selectedUuid.length === 0) {
            message.error("未选中楼层，请选中后再保存");
            setLoading(false);
            setEditing(false);
            return;
        }
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) {
            message.error("图形编辑器未激活");
            setLoading(false);
            setEditing(false);
            return;
        }
        let entities: ModelBase[] = editor.selectControl.getSelectedEntityList();
        let tmpSelectSet = new Set(entities.map(entity => entity.uuid));
        if (entities.length === 0) {
            TnModal().baseModal({
                title: "确认",
                content: "当前选中图元数为0，确认按钮会清空当前楼层编组",
                onOk: () => {
                    Object.keys(editor.entityDict).forEach(uuid => {
                        let entity = editor.entityDict[uuid];
                        if (entity && selectedSet.has(entity.uuid)) {
                            //之前被选中的但是现在没有被选中的，删除编组信息
                            if (entity.group && entity.group[GroupType.STOREY]) {
                                delete entity.group[GroupType.STOREY];
                                entities.push(entity);
                            }
                        }
                    })
                    createPrimitiveMulti(entities.map(entity => entity.toJson()), { modelUuid: modelUuid, projectUuid: projectUuid }).then(res => {
                        if (res.status === 200) {
                            message.success("楼层编组成功");
                        }
                    }).finally(() => {
                        setLoading(false);
                        setEditing(false);
                        Modal.destroyAll();
                    });




                },
                onCancel: () => {
                    editor.listeners.signals.emptySelectedEntities.dispatch();
                    message.info("取消楼层编组操作");
                    setLoading(false);
                    setEditing(false);
                    Modal.destroyAll();
                }
            })
            return;
        } else {
            entities.forEach(entity => {
                if (!entity.group) {
                    entity.group = {};
                }
                entity.group[GroupType.STOREY] = [selectedUuid];
            });
            Object.keys(editor.entityDict).forEach(uuid => {
                let entity = editor.entityDict[uuid];
                if (entity && selectedSet.has(entity.uuid) && !tmpSelectSet.has(entity.uuid)) {
                    //之前被选中的但是现在没有被选中的，删除编组信息
                    if (entity.group && entity.group[GroupType.STOREY]) {
                        delete entity.group[GroupType.STOREY];
                        entities.push(entity);
                    }
                }
            })
            createPrimitiveMulti(entities.map(entity => entity.toJson()), { modelUuid: modelUuid, projectUuid: projectUuid }).then(res => {
                if (res.status === 200) {
                    message.success("楼层编组成功");
                }
            }).finally(() => {
                setLoading(false);
                setEditing(false);
            });

        }
    }

    const onCancel = () => {
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) {
            message.warning("图形编辑器未激活");
            return;
        }
        editor.listeners.signals.emptySelectedEntities.dispatch();
        message.info("取消楼层编组操作");
    }


    const onClickEditStoreyNumber = (storey: Storey) => {
        setSelectedUuid(storey.uuid);
        setEditStoreyNumberModalOpen(true);
        // 手动设置表单的字段值，确保表单字段的值是最新的
        form.setFieldsValue({ storeyNumber: storey.storeyNumber });
    };

    // 保存楼层号的回调函数
    const onConfirmSaveStoreyNumber = () => {
        form.validateFields().then(values => {
            const updatedStoreyNumber = values.storeyNumber;
            if (!selectedUuid) return; // 确保有选中的楼层

            // 更新数据库中的楼层号
            updateStorey(selectedUuid, { storeyNumber: updatedStoreyNumber }).then(res => {
                if (res.status === 200) {
                    message.success("楼层号更新成功");
                    // 更新前端显示的楼层信息
                    generateData();
                }
            }).catch(err => {
                message.error("楼层号更新失败");
            }).finally(() => {
                setEditStoreyNumberModalOpen(false);
                form.resetFields();
            });
        });
    };

    return (
        // <div>123</div>
        <div className="side-bar-main storey-panel">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    楼层
                </div>
                <div className="head">
                    楼层列表
                </div>


                <div className="detail">
                    {storeyList.map((storey, index) => {
                        return (
                            <div className={classNames({
                                "storey-item": true,
                                "selected": storey.uuid === selectedUuid

                            })} key={index}>
                                <span>{storey.name}</span>
                                {/* <div className="right-svg" onClick={() => { onEditiingClick(storey.uuid, index) }}>
                                    {loading ? <LoadingOutlined className="svg" /> : <EditSvg className="svg" />}
                                </div>
                                <div className="right-svg" onClick={() => onClickEditStoreyNumber(storey)}>
                                    <LinkSvg className="svg" />
                                </div> */}
                                <div className='right-svg'>
                                    {loading ? <LoadingOutlined className="svg" /> : <EditSvg className="svg" onClick={() => { onEditiingClick(storey.uuid, index) }} />}
                                    <LinkSvg className='svg' onClick={() => { onClickEditStoreyNumber(storey) }} />
                                    <BindSvg className='svg' onClick={() => onClickShowBindModel(storey)} />
                                </div>
                            </div>
                        )
                    })}
                    {!loading &&
                        <div className="bottom-panel">
                            <div className="btn save" onClick={onSave}>确定</div>
                            <div className="btn cancel" onClick={onCancel}>取消</div>
                        </div>
                    }
                    {loading &&
                        <div className="bottom-panel">
                            <LoadingOutlined />
                        </div>
                    }



                </div>
            </div>

            <ConfirmModal
                title={"场景绑定分层"}
                visible={showBindModel}
                setVisible={(e) => setShowBindModel(e)}
                onSaveClick={onClickBind}
                wrapClassName="create-project-modal"
                saveDisable={bindLoading}
            >
                <div className="create-project-body">
                    <Form
                        colon={false}
                        form={bindModelForm}
                        autoComplete="off"
                        labelCol={{ span: 5 }}
                        onFinish={onBindModel}
                    >
                        <Form.Item label="楼层:" name="storeyUuid" hidden></Form.Item>
                        <Form.Item label="文件名:" name="objUuid">
                            <Select options={objList.map(obj => {
                                console.log('obj', obj)
                                return { label: obj.originName, value: obj.id }
                            })} filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                showSearch allowClear></Select>
                        </Form.Item>
                        <Button loading={loading} ref={btnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                    </Form>
                </div>
            </ConfirmModal>

            <ConfirmModal
                title={"绑定楼层号"}
                visible={editStoreyNumberModalOpen}
                setVisible={setEditStoreyNumberModalOpen}
                onSaveClick={onConfirmSaveStoreyNumber}
                wrapClassName="create-project-modal"
                saveDisable={loading}
            >
                <div className="create-project-body">
                    <Form
                        colon={false}
                        form={form}
                        autoComplete="off"
                        labelCol={{ span: 5 }}
                    >
                        <Form.Item
                            label="楼层号:"
                            name="storeyNumber"
                            rules={[{ required: true, message: '楼层号不能为空' }]}
                        >
                            <Input type="number" autoFocus />
                        </Form.Item>
                        <Button loading={loading} htmlType="submit" style={{ display: 'none' }}></Button>
                    </Form>
                </div>
            </ConfirmModal>
        </div >
    )

}